import { appConstants } from '../config/constant';

declare var AppStorageUtil: any;

export function getManufacturingLocation(): string {
  return AppStorageUtil.getItem('manufacturingLocation') || '';
}

export function isPackagesPageEligible(location?: string): boolean {
  const loc = location ?? getManufacturingLocation();
  const { US, Canada, Mexico } = appConstants.UserLocation;
  return loc === US || loc === Canada || loc === Mexico;
}

export function shouldShowLegacyUpgradePopup(location?: string): boolean {
  const loc = location ?? getManufacturingLocation();
  const { Asia, Europe } = appConstants.UserLocation;
  return loc === Asia || loc === Europe;
}
